import { CLR, NIGHT } from './_constants';
import Cookies from 'universal-cookie';

const cookies = new Cookies('');

/**
 * Get RGBA from hex colors.
 * @function getRGBA
 * @param {string} hex - hex color.
 * @param {decimal} alpha - opacity from 0 - 1.
 */
const getRGBA = (hex, alpha) =>
    `rgba(${parseInt(hex.substring(1, 3), 16)},${parseInt(hex.substring(3, 5), 16)},${parseInt(
        hex.substring(5, 7),
        16,
    )},${alpha})`;

const MAIN = CLR;

const {
    bgGross,
    genHappy,
    shadow,
    genInactive,
    green,
    greenMedium,
    greenLight,
    bodyLight,
    greyMidLight,
    greyLight,
    bgTertiary,
    bodyLightest,
    iron,
    genPositive,
    lightBlueGreyTwo,
    manatee,
    body,
    orange,
    paleBlue,
    paleYellow,
    border,
    generalWarning,
    generalWarningLight,
    bgPrimary,
    brandPrimary,
    linkWater,
    gallery,
    genProcessing,
    lemon,
} = MAIN;

export default {
    // BRAND
    brandPrimary,
    genHappy,
    greyMidLight,

    // BACKGROUND
    bgPrimary,
    body,
    bgTertiary,
    bgGross,
    lemon,

    // BODY
    bodyLight,
    bodyLightest,

    // GENERAL, THESE CAN BE USED AS BOTH BG OR BODY
    generalWarning,
    orange,
    genPositive,
    genProcessing,
    genInactive,
    genHappy,

    // BORDER
    border,
    shadow,
    sub: manatee,
    disabledText: iron,
    starEmpty: lightBlueGreyTwo,

    getRGBA,
};



// WEBPACK FOOTER //
// ./src/styles/colors.js